import { jsxs as o, jsx as r } from "react/jsx-runtime";
import l from "classnames";
import a from "./index.es681.js";
import { SpecialUpgradeIcon as s } from "./index.es682.js";
import { BodyText as t } from "./index.es505.js";
const m = "upsell-label", L = ({ testId: e = m }) => /* @__PURE__ */ o("div", { className: l(a.label), "data-testid": e, children: [
  /* @__PURE__ */ r(s, {}),
  /* @__PURE__ */ r(t, { variant: "semi-bold", color: "primary-brand", children: "Upgrade" })
] });
export {
  m as UPSELL_LABEL_DEFAULT_TESTID,
  L as UpsellLabel
};
//# sourceMappingURL=index.es156.js.map
